<template>
  <div>
    <h2 class="content-block-title">{{ title }}</h2>

    <dx-data-grid
      v-if="!loading"
      class="dx-card content-block"
      :data-source="dataSource"
      key-expr="path"
      :focused-row-index="0"
      :show-borders="false"
      :focused-row-enabled="true"
      :column-auto-width="true"
      :column-hiding-enabled="true"
    >
      <dx-paging :page-size="10" />
      <dx-pager :show-page-size-selector="true" :show-info="true" />
      <dx-filter-row :visible="true" />

      <dx-column data-field="common_name" caption="Common Name" />
      <dx-column data-field="issuer" caption="Issuer" />
      <dx-column data-field="not_before" caption="Valid From" data-type="date" format="yyyy-MM-dd HH:mm:ss" />
      <dx-column data-field="not_after" caption="Valid Until" data-type="date" format="yyyy-MM-dd HH:mm:ss" />
      <dx-column data-field="days_remaining" caption="Days Left" />
      <dx-column data-field="expired" caption="Expired" cell-template="expiredCellTemplate" />
      <dx-column data-field="expiring_soon" caption="Expiring Soon" cell-template="expiringSoonCellTemplate" />
      <dx-column data-field="path" caption="Certificate Path" />

      <template #expiredCellTemplate="{ data }">
        <span :class="['tag-pill', data.value ? 'tag-expired' : 'tag-ok']">
          {{ data.value ? 'Yes' : 'No' }}
        </span>
      </template>

      <template #expiringSoonCellTemplate="{ data }">
        <span :class="['tag-pill', data.value ? 'tag-warning' : 'tag-ok']">
          {{ data.value ? 'Soon' : 'No' }}
        </span>
      </template>
    </dx-data-grid>

    <div v-if="loading" class="loading-overlay">
      <DxLoadIndicator :height="60" :width="60" />
    </div>
  </div>
</template>

<script>
import { DxDataGrid, DxColumn, DxPaging, DxPager, DxFilterRow } from 'devextreme-vue/data-grid';
import { DxLoadIndicator } from 'devextreme-vue/load-indicator';

export default {
  name: 'CertificateGrid',
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxPager,
    DxFilterRow,
    DxLoadIndicator
  },
  data() {
    return {
      title: 'SSL Certificates Overview',
      loading: true,
      dataSource: []
    };
  },
  mounted() {
    this.loadCertificates();
  },
  methods: {
    async loadCertificates() {
      try {
        // Replace the below line with your actual API call
        const response = await fetch('/internal/haproxy/certs');
        const json = await response.json();
        this.dataSource = json;
      } catch (error) {
        console.error('Failed to load certificates:', error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 10;
}

.tag-pill {
  padding: 4px 8px;
  border-radius: 12px;
  font-weight: 500;
  font-size: 12px;
  display: inline-block;
  color: white;
}

.tag-ok {
  background-color: #4caf50;
}

.tag-warning {
  background-color: #ff9800;
}

.tag-expired {
  background-color: #f44336;
}
</style>
